import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  TextField,
  Stack,
  Alert,
  InputAdornment,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";

import postApiData from "../../../../hooks/apiRequests/postsRequest";
import { useToast } from "../../../shared/toastMessages/toastProvider";
import { theme } from "../../../../configs/theme";
import AuthCard, { authButtonSx, authFieldSx } from "../../common/authCard";

const UnlockAccount = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setSubmitted(false);
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      showToast("Please enter your email", "error");
      return;
    }

    setSubmitting(true);
    try {
      const response = await postApiData("/Send/UnlockAccount", {
        email: trimmed,
      });
      if (response?.status === 204 || response?.data) {
        showToast(
          "If that account exists, an unlock email has been sent.",
          "success"
        );
      } else {
        showToast("Unable to send unlock request", "error");
      }
    } catch (error) {
      showToast("Unable to send unlock request", "error");
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <AuthCard
      title="Unlock account"
      subtitle={
        submitted
          ? "Check your inbox for unlock instructions."
          : "Enter your email and we’ll send a link to unlock your account and set a new password."
      }
      footerTitle="Have an account?"
      footerActionLabel="Back to login"
      onFooterAction={() => navigate("/")}
    >
      {!submitted ? (
        <Stack component="form" spacing={2} onSubmit={handleSubmit}>
          <TextField
            id="email"
            label="Email"
            type="email"
            autoComplete="email"
            theme={theme}
            variant="outlined"
            size="small"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            sx={authFieldSx}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <EmailOutlinedIcon fontSize="small" color="action" />
                </InputAdornment>
              ),
            }}
          />
          <Button
            type="submit"
            variant="contained"
            theme={theme}
            disabled={submitting}
            fullWidth
            sx={authButtonSx}
          >
            {submitting ? "Sending..." : "Send unlock email"}
          </Button>
        </Stack>
      ) : (
        <Stack spacing={2}>
          <Alert severity="success" sx={{ borderRadius: "10px" }}>
            If that account exists, an unlock email has been sent. Please check
            your inbox.
          </Alert>
          <Button
            onClick={() => navigate("/")}
            variant="contained"
            theme={theme}
            fullWidth
            sx={authButtonSx}
          >
            Back to login
          </Button>
        </Stack>
      )}
    </AuthCard>
  );
};

export default UnlockAccount;
